import axios from "axios";
const apiClient = axios.create({
  // baseURL: `http://localhost:3000`,
  // baseURL: "http://connectivitystaging",

  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  timeout: 30000,
});
export default {
  getNewToken() {
    return apiClient({
      method: "GET",
      url: "/api",
    });
  },
  getProfile(token) {
    return apiClient({
      method: "GET",
      url: "/api",
      data: {},
      params: { token: token },
    });
  },
  saveProfile(token, version, profileData) {
    return apiClient({
      method: "POST",
      url: "/api",
      params: { token: token, version: version },
      data: profileData,
      timeout: 40000,
    });
  },
  submitPost(token, reqId, formData) {
    return apiClient({
      headers: {
        "Content-Type": "multipart/form-data",
        token: token,
        id: reqId,
      },
      method: "POST",
      url: "/api/submit",
      // params: { token: token, version: version },
      data: formData,
      timeout: 10000,
    });
  },
  createDxf(token, reqId, jsonConfig) {
    return apiClient({
      headers: { token: token, id: reqId },
      timeout: 30000,
      method: "POST",
      url: "/api/dxf",
      data: jsonConfig,
    });
  },
  /*  getDxf(dxfName) {
    return apiClient({
      responseType: "blob",
      timeout: 30000,
      method: "POST",
      url: "/api/dxfdl",
      data: { dxfFilename: dxfName }
    });
  } */
};
